const isGray = /(\.\w+|localhost)(:\d+)?(\/new)/.test(window.location.href);

const ClientIsGrayHttpDate = { clientIsGray: isGray ? 1 : 0 };

// 切换版本（灰度<->正式）
const ChangeEnvironment = () => {
  const temp = window.location.origin + window.location.pathname;
  if (isGray) {
    window.location.href = window.location.href.replace(temp, temp.replace('/new', ''));
    return;
  }
  window.location.href = window.location.href.replace(temp, `${window.location.origin}/new${window.location.pathname}`);
};

const GetParamsForClientIsGrayHttpDate = () => ClientIsGrayHttpDate;

export {
  isGray,
  ClientIsGrayHttpDate,
  ChangeEnvironment,
  GetParamsForClientIsGrayHttpDate,
};
